/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/education.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/education.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/education.mdx';

const metadata = {
  slug: "education",
  title: "Trickle-Down Teaching is Dead; Long Live HQIM",
  author: "Christian Battaglia",
  description: "A deep dive into the K-12 education industry — from the history of public education reform to the barriers facing EdTech entrepreneurs, and why \"high quality instructional materials\" (HQIM) represent a new era after decades of failed silver bullets.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-12-18T00:00:00.000Z",
  
  readTime: "12 min read",
  tags: ["education","HQIM","EdTech","Amplify","K-12","curriculum","non-profit","procurement","Larry Berger"],
};

export const Route = createFileRoute('/blog/posts/education')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/education',
    image: '/og/blog/education.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
